import { createAction, props } from '@ngrx/store';
import { ISignInRes } from '../../shared/models/auth.model';

export const signIn = createAction('[Auth] login', props<{ response: ISignInRes }>());
export const signInSuccess = createAction('[Auth] login Success', props<{ response: ISignInRes }>());
export const signInFailure = createAction('[Auth] login Failure', props<{ error: any }>());
export const logout = createAction('[Auth] Logout');
